export default __webpack_public_path__ + "static/media/Theme6.54e848bd.jpg";